import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";

const ArchiveConfirmationModal = ({
  isOpen,
  onClose,
  onConfirmDelete,
  isLoading,
  title,
  value,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm {value?.toLowerCase()}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{title}</ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme={value === "Archive" ? "orange" : "green"}
            onClick={onConfirmDelete}
            isLoading={isLoading}
            loadingText={value}
          >
            {value}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ArchiveConfirmationModal;
